import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<PreviewComponent>,
      @Inject(MAT_DIALOG_DATA) public modalData: any,
      private sanitizer: DomSanitizer
    ) { }

  ngOnInit(): void {
    // console.log(this.modalData);    
  }

  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }

  closeModal() {
    this.dialogRef.close();
  }

}
